export default "__VITE_ASSET__Dp6pS$hU__"